import React from "react";
import { useState } from "react";
import "./sectionNine.css";

const SectionNine = () => {
  const [faq1, setFaq1] = useState(true);
  const [faq2, setFaq2] = useState(false);
  const [faq3, setFaq3] = useState(false);
  const [faq4, setFaq4] = useState(false);
  const [faq5, setFaq5] = useState(false);
  const [faq6, setFaq6] = useState(false);

  // faq1
  const handleFaq1Opening = () => {
    // toggle
    setFaq1((prev) => !prev);
    // close others
    setFaq2(false);
    setFaq3(false);
    setFaq4(false);
    setFaq5(false);
    setFaq6(false);
  };
  // faq2
  const handleFaq2Opening = () => {
    // toggle
    setFaq2((prev) => !prev);
    // close others
    setFaq1(false);
    setFaq3(false);
    setFaq4(false);
    setFaq5(false);
    setFaq6(false);
  };
  // faq3
  const handleFaq3Opening = () => {
    // toggle
    setFaq3((prev) => !prev);
    // close others
    setFaq1(false);
    setFaq2(false);
    setFaq4(false);
    setFaq5(false);
    setFaq6(false);
  };
  // faq4
  const handleFaq4Opening = () => {
    // toggle
    setFaq4((prev) => !prev);
    // close others
    setFaq1(false);
    setFaq2(false);
    setFaq3(false);
    setFaq5(false);
    setFaq6(false);
  };
  // faq5
  const handleFaq5Opening = () => {
    // toggle
    setFaq5((prev) => !prev);
    // close others
    setFaq1(false);
    setFaq2(false);
    setFaq3(false);
    setFaq4(false);
    setFaq6(false);
  };
  // faq6
  const handleFaq6Opening = () => {
    // toggle
    setFaq6((prev) => !prev);
    // close others
    setFaq1(false);
    setFaq2(false);
    setFaq3(false);
    setFaq4(false);
    setFaq5(false);
  };

  return (
    <>
      <div className="sectionNine-main-wrapper" style={{marginTop: '-5px'}}>
        <div className="faq-innerWrapper">
          <div>
            <h1 className="faq-title">FAQS</h1>
            {/* faq 1 start */}
            <div className="faq-accordion-item">
              <h5>
                What is Party Potato Club?
                {faq1 ? (
                  <span className="cup" onClick={() => handleFaq1Opening()}>-</span>
                ) : (
                  <span className="cup" onClick={() => handleFaq1Opening()}>+</span>
                )}
              </h5>
              <p style={!faq1 ? { display: "none" } : null}>
                Party Potato Club is a community driven NFT project that rewards
                its holders with passive income opportunities, free NFT airdrops
                from our future collections and genuine utility in the space.
              </p>
            </div>
            {/* faq 1 end */}
            {/* faq 2 start */}
            <div className="faq-accordion-item">
              <h5>
                When is the mint?{" "}
                {faq2 ? (
                  <span className="cup" onClick={() => handleFaq2Opening()}>-</span>
                ) : (
                  <span className="cup" onClick={() => handleFaq2Opening()}>+</span>
                )}
              </h5>
              <p style={!faq2 ? { display: "none" } : null}>
                Party Potato Club is a community driven NFT project that rewards
                its holders with passive income opportunities, free NFT airdrops
                from our future collections and genuine utility in the space.
              </p>
            </div>
            {/* faq 2 end */}
            {/* faq 3 start */}
            <div className="faq-accordion-item">
              <h5>
                Will there be a whitelist?{" "}
                {faq3 ? (
                  <span className="cup" onClick={() => handleFaq3Opening()}>-</span>
                ) : (
                  <span className="cup" onClick={() => handleFaq3Opening()}>+</span>
                )}
              </h5>
              <p style={!faq3 ? { display: "none" } : null}>
                Party Potato Club is a community driven NFT project that rewards
                its holders with passive income opportunities, free NFT airdrops
                from our future collections and genuine utility in the space.
              </p>
            </div>
            {/* faq 3 end */}
            {/* faq 4 start */}
            <div className="faq-accordion-item">
              <h5>
                How much for a partying tater?{" "}
                {faq4 ? (
                  <span className="cup" onClick={() => handleFaq4Opening()}>-</span>
                ) : (
                  <span className="cup" onClick={() => handleFaq4Opening()}>+</span>
                )}
              </h5>
              <p style={!faq4 ? { display: "none" } : null}>
                Party Potato Club is a community driven NFT project that rewards
                its holders with passive income opportunities, free NFT airdrops
                from our future collections and genuine utility in the space.
              </p>
            </div>
            {/* faq 4 end */}
            {/* faq 5 start */}
            <div className="faq-accordion-item">
              <h5>
                How many potatoes can I mint?{" "}
                {faq5 ? (
                  <span className="cup" onClick={() => handleFaq5Opening()}>-</span>
                ) : (
                  <span className="cup" onClick={() => handleFaq5Opening()}>+</span>
                )}
              </h5>
              <p style={!faq5 ? { display: "none" } : null}>
                Party Potato Club is a community driven NFT project that rewards
                its holders with passive income opportunities, free NFT airdrops
                from our future collections and genuine utility in the space.
              </p>
            </div>
            {/* faq 5 end */}
            {/* faq 6 start */}
            <div className="faq-accordion-item" style={{border: 'none'}}>
              <h5>
                Is your smart contract gas efficient?{" "}
                {faq6 ? (
                  <span className="cup" onClick={() => handleFaq6Opening()}>-</span>
                ) : (
                  <span className="cup" onClick={() => handleFaq6Opening()}>+</span>
                )}
              </h5>
              <p style={!faq6 ? { display: "none" } : null}>
                Party Potato Club is a community driven NFT project that rewards
                its holders with passive income opportunities, free NFT airdrops
                from our future collections and genuine utility in the space.
              </p>
            </div>
            {/* faq 6 end */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionNine;
